import { render, staticRenderFns } from "./ClientDropdown.vue?vue&type=template&id=37d7a74c&"
import script from "./ClientDropdown.vue?vue&type=script&lang=ts&"
export * from "./ClientDropdown.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QBtn,QPopupProxy,QList,QItem,QItemSection,QItemLabel} from 'quasar'
component.options.components = Object.assign({QBtn,QPopupProxy,QList,QItem,QItemSection,QItemLabel}, component.options.components || {})
